import { ViewChild } from "@angular/core";
import { Router } from "@angular/router";
import { ColDef, ColumnApi, GridApi } from "ag-grid";
import { AgOverlayTemplate } from "app/components";
import { ConsultRequestSummaryData } from "app/services/sales/model/ConsultRequestSummaryData";
import { NewUserListGridViewModel } from "../user/new-user-list.viewmodel.grid";

export class ConsultingMonitoringGridViewModel {

    public gridApi: GridApi;
    public gridColumnApi: ColumnApi;

    public overlayLoadingTemplate = AgOverlayTemplate.overlayProcessingTemplate;

    constructor(private router: Router) {

    }


    private toConsultPage(param) {
        const summaryData: ConsultRequestSummaryData = param.data;

        let div = document.createElement("div");

        let btnLog = document.createElement("button");
        btnLog.innerHTML = "이력";
        btnLog.setAttribute('class', NewUserListGridViewModel.btnClass);
        btnLog.addEventListener("click", (e) => {
            window.open(document.baseURI + "quotation/consult-list?startDt=20170101&userId=" + summaryData.userId, "_blank");
        });

        div.appendChild(btnLog);

        return div;
    }

    showMessageBtnCallback:(data: ConsultRequestSummaryData) => void;

    private showMessageModal(param) {
        const summaryData: ConsultRequestSummaryData = param.data;

        let div = document.createElement("div");

        let btnMessage = document.createElement("button");
        if (summaryData.hasMessage) {
            btnMessage.innerHTML = "메세지 확인";
        } else {
            btnMessage.innerHTML = "신규 작성";
        }
        
        btnMessage.setAttribute('class', NewUserListGridViewModel.btnClass);
        btnMessage.addEventListener("click", (e) => {
            if (this.showMessageBtnCallback) {
                this.showMessageBtnCallback(summaryData);
            }
        });

        div.appendChild(btnMessage);

        return div;
    }


    public columnDefinitions = [
        { headerName: "User Id", field: "userId", resizable: true, width: 160, sortable: true, filter: 'agTextColumnFilter' },
        { headerName: "이메일", field: "email", resizable: true, width: 250, sortable: true, filter: 'agTextColumnFilter' },
        { headerName: "성명", field: "fullName", resizable: true, width: 100, sortable: true, filter: 'agTextColumnFilter' },
        // { headerName: "직업 구분", field: "jobTpText", resizable: true, width: 100, sortable: true, filter: 'agTextColumnFilter' },
        { headerName: "회사 명", field: "cmpnyNm", resizable: true, width: 250, sortable: true, filter: 'agTextColumnFilter' },
        { headerName: "휴대폰", field: "mobile", resizable: true, width: 150, sortable: true, filter: 'agTextColumnFilter' }
    ];

    public columnDefinitionExtensionRequest = [
        { headerName: "요청번호", field: "reqNo", resizable: true, width: 160, sortable: true, filter: 'agTextColumnFilter' },
        { headerName: "요청일시", field: "reqDtmLocalStr", resizable: true, width: 160, sortable: true, filter: 'agTextColumnFilter' },
        { headerName: "참여 견적", field: "quotCnt", resizable: true, width: 90, sortable: true, filter: 'agTextColumnFilter' },
        { headerName: "만료 예정", field: "willBeUnAvailableCnt", resizable: true, width: 90, sortable: true, filter: 'agTextColumnFilter' }
    ];

    public columnDefinitionExtensionComplete = [
        { headerName: "요청번호", field: "reqNo", resizable: true, width: 160, sortable: true, filter: 'agTextColumnFilter' },
        { headerName: "운송 완료일", field: "completeTransDtmLocalStr", resizable: true, width: 160, sortable: true, filter: 'agTextColumnFilter' },
    ];

    public columnDefinitionExtensionSummary = [
        { headerName: "견적 요청", field: "requestCnt", resizable: true, width: 90, sortable: true, filter: 'agTextColumnFilter' },
        { headerName: "견적 수취", field: "hasQuotCnt", resizable: true, width: 90, sortable: true, filter: 'agTextColumnFilter' },
        { headerName: "진행중", field: "processingCnt", resizable: true, width: 90, sortable: true, filter: 'agTextColumnFilter' },
        // { headerName: "최근 완료 건(100시간)", field: "currentRequestCnt", resizable: true, width: 90, sortable: true, filter: 'agTextColumnFilter' },
        // { headerName: "요청 대기 중", field: "notConfirmedCnt", resizable: true, width: 90, sortable: true, filter: 'agTextColumnFilter' },
        { headerName: "운송 완료", field: "transportCompleteCnt", resizable: true, width: 90, sortable: true, filter: 'agTextColumnFilter' },
    ];

    public columnDefinitionExtensionLingo = [
        { headerName: "Lingo 승인 상태", field: "lingoStatus", resizable: true, width: 90, sortable: true, filter: 'agTextColumnFilter' },
    ];

    public postfixColumnDefinitions = [
        { headerName: "", field: "userId", resizable: true, width: 90, cellRenderer: this.toConsultPage },
        { headerName: "메세지", field: "hasMessage", resizable: true, width: 115, cellRenderer: (param) => {return this.showMessageModal(param)} },
        { headerName: "담당자", field: "salesManagerFullName", resizable: true, width: 100, sortable: true, filter: 'agTextColumnFilter' },
        { headerName: "가입일시", field: "userRegDtLocalStr", resizable: true, width: 160, sortable: true }
        
    ];


    public onGridReady(params) {
        this.gridApi = params.api;
        this.gridColumnApi = params.columnApi;
        this.hideLoading();
    }

    public showLoading() {
        this.gridApi.showLoadingOverlay();
    }

    public hideLoading() {
        this.gridApi.hideOverlay();
    }

    public updateColumnDefinitions(hasSummaries?: boolean, hasRequest?: boolean, hasComplete?: boolean, hasLingoStatus?: boolean) {
        let definitions : any[] = this.columnDefinitions;

        if (hasRequest) {
            definitions = definitions.concat(this.columnDefinitionExtensionRequest);
        }

        if (hasSummaries) {
            definitions = definitions.concat(this.columnDefinitionExtensionSummary);
        }

        if (hasComplete) {
            definitions = definitions.concat(this.columnDefinitionExtensionComplete);
        }

        definitions = definitions.concat(this.postfixColumnDefinitions);

        if (hasLingoStatus) {
            definitions = definitions.concat(this.columnDefinitionExtensionLingo);
        }
        
        this.gridApi.setColumnDefs(definitions);
    }


}


// WEBPACK FOOTER //
// ./src/app/containers/sales/consulting-monitoring.viewmodel.grid.ts